
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import ChatGroupList from './ChatGroupList';
import CreateChatModal from './CreateChatModal';

interface MobileChatGroupsViewProps {
  chatGroups: any[];
  selectedGroup: any;
  onSelectGroup: (group: any) => Promise<void>;
  canCreateGroup: boolean;
}

const MobileChatGroupsView = ({
  chatGroups,
  selectedGroup,
  onSelectGroup,
  canCreateGroup
}: MobileChatGroupsViewProps) => {
  const [showCreateModal, setShowCreateModal] = useState(false);

  return (
    <div className="flex flex-col h-full bg-black text-white">
      {/* Header */}
      <div className="flex items-center justify-between p-4 border-b border-gray-800 bg-gray-900">
        <h1 className="text-xl font-bold text-white">Chat Groups</h1>
        {canCreateGroup && (
          <Button
            size="sm"
            onClick={() => setShowCreateModal(true)}
            className="bg-sports-green hover:bg-sports-green/90 text-black"
          >
            <Plus className="h-4 w-4" />
          </Button>
        )}
      </div>

      {/* Groups List */}
      <div className="flex-1 overflow-hidden">
        <ChatGroupList
          chatGroups={chatGroups}
          selectedGroup={selectedGroup}
          onSelectGroup={onSelectGroup}
        />
      </div>

      {/* Create Chat Modal */}
      {showCreateModal && (
        <CreateChatModal
          isOpen={showCreateModal}
          onClose={() => setShowCreateModal(false)}
        />
      )}
    </div>
  );
};

export default MobileChatGroupsView;
